import { Enums } from "./enums";

export const Links = {
    Url(o, args) {
        if (o) {
            if (o._route) { return "/"; }
            if (o.path) {
                let path = "/" + o.path;
                if (args != null) {
                    if (!Array.isArray(args)) {
                        args = [args];
                    }
                    for (let i = 0; i < args.length; i++) {
                        try {
                            path = path.replaceAll("{" + i + "}", args[i].toString());
                        } catch (e) {
                            console.error(e);
                        }
                    }
                }
                // Geçersiz argsları kaldır.
                path = path.replace(/\{\d+\}\//g, "0").replace(/\{[^\}]*\}/g, "0")
                return path;
            }
        }
        console.error("Geçersiz link:" + o);
    },
    GetMenu(text, icon, o) {
        if (o) {
            if (Array.isArray(o)) {
                return { text: text, class: "fa fa-" + icon, child: o };
            }
            let args = [];
            for (let i = 3; i < arguments.length; i++) {
                args.push(arguments[i]);
            }
            return { text: text, class: "fa fa-" + icon, link: Links.Url(o, args), };
        }
        console.error("Geçersiz link:" + o);
    },
    Home: {
        path: "panel",
        component: 'DashboardView',
        title: "Anasayfa",
        theme: Enums.THEME.CLASSIC
    },
    Login: {
        path: "login",
        component: 'user/LoginView',
        title: "Giriş",
        theme: Enums.THEME.EMPTY
    },   

    Announcement: {
        List: {
            path: "announcement/list",
            component: 'announcement/ListView',
            title: "Duyuru Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "announcement/edit/{0}",
            component: 'announcement/EditView',
            title: "Duyuru İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    Contact: {
        List: {
            path: "contact/list",
            component: 'contact/ListView',
            title: "Destek/Talep Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "contact/edit/{0}",
            component: 'contact/EditView',
            title: "Destek/Talep İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    Contract: {
        List: {
            path: "contract/list",
            component: 'contract/ListView',
            title: "Sözleşme Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "contract/edit/{0}",
            component: 'contract/EditView',
            title: "Sözleşme İşlem",
            theme: Enums.THEME.CLASSIC
        },
        Convert: {
            path: "contract/convert",
            component: 'contract/ConvertView',
            title: "Sözleşme Dönüşüm",
            theme: Enums.THEME.CLASSIC
        },
    },
    Customer: {
        List: {
            props: [":type"],
            path: "customer/list/{0}",
            component: 'customer/ListView',
            title: "Üye Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "customer/edit/{0}",
            component: 'customer/EditView',
            title: "Üye İşlem",
            theme: Enums.THEME.CLASSIC
        },
        Card: {
            props: [":id"],
            path: "customer/card/{0}",
            component: 'customer/CardView',
            title: "Üye Kartı",
            theme: Enums.THEME.CLASSIC
        },
    },
    GlobalFile: {
        List: {
            props: [":type"],
            path: "global-file/list/{0}",
            component: 'global-file/ListView',
            title: "Doküman Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "global-file/edit/{0}",
            component: 'global-file/EditView',
            title: "Doküman İşlem",
            theme: Enums.THEME.CLASSIC
        },
        CategoryList: {
            path: "global-file/category-list",
            component: 'global-file/CategoryListView',
            title: "Doküman Kategori Listele",
            theme: Enums.THEME.CLASSIC
        },
        CategoryEdit: {
            props: [":id"],
            path: "global-file/category-edit/{0}",
            component: 'global-file/CategoryEditView',
            title: "Doküman Kategori İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    Lesson: {
        List: {
            path: "lesson/list",
            component: 'lesson/ListView',
            title: "Ders Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "lesson/edit/{0}",
            component: 'lesson/EditView',
            title: "Ders İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    LessonArea : {
        List: {
            path: "lesson-area/list",
            component: 'lesson-area/ListView',
            title: "Sınav Türü Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "lesson-area/edit/{0}",
            component: 'lesson-area/EditView',
            title: "Sınav Türü İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    LessonGroup: {
        List: {
            path: "lesson-group/list",
            component: 'lesson-group/ListView',
            title: "Snav Alanı Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "lesson-group/edit/{0}",
            component: 'lesson-group/EditView',
            title: "Snav Alanı İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    LessonTeacher: {
        List: {
            path: "lesson-teacher/list",
            component: 'lesson-teacher/ListView',
            title: "Ders Hocası Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "lesson-teacher/edit/{0}",
            component: 'lesson-teacher/EditView',
            title: "Ders Hocası İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    HowToStudy: {
        List: {
            path: "how-to-study/list",
            component: 'how-to-study/ListView',
            title: "Nasıl Çalışılır Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "how-to-study/edit/{0}",
            component: 'how-to-study/EditView',
            title: "Nasıl Çalışılır İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    ClassRoom: {
        List: {
            path: "class-room/list",
            component: 'class-room/ListView',
            title: "Snıf Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "class-room/edit/{0}",
            component: 'class-room/EditView',
            title: "Snıf İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },

    Trial: {
        List: {
            path: "triall/list",
            component: 'trial/ListView',
            title: "Deneme Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "trial/edit/{0}",
            component: 'trial/EditView',
            title: "Deneme İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    Package: {
        List: {
            path: "package/list",
            component: 'package/ListView',
            title: "Paket Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "package/edit/{0}",
            component: 'package/EditView',
            title: "Paket İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    Payment: {
        List: {
            props: [":type"],
            path: "payment/list/{0}",
            component: 'payment/ListView',
            title: "Ödeme Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "payment/edit/{0}",
            component: 'payment/EditView',
            title: "Ödeme İşlem",
            theme: Enums.THEME.CLASSIC
        },
        ProcessList: {
            path: "payment/process-list",
            component: 'payment/ProcessListView',
            title: "Hakediş Listele",
            theme: Enums.THEME.CLASSIC
        },
    },
    QuestionPool: {
        List: {
            path: "question-pool/list",
            component: 'question-pool/ListView',
            title: "Soru Havuzu Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "question-pool/edit/{0}",
            component: 'question-pool/EditView',
            title: "Soru Havuzu İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    TestPool: {
        List: {
            path: "test-pool/list",
            component: 'test-pool/ListView',
            title: "Test Havuzu Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "test-pool/edit/{0}",
            component: 'test-pool/EditView',
            title: "Test Havuzu İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    ResourceBook: {
        List: {
            path: "resource-book/list",
            component: 'resource-book/ListView',
            title: "Kaynak Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "resource-book/edit/{0}",
            component: 'resource-book/EditView',
            title: "Kaynak İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },    
    Message: {
        Listele: {
            path: "message/list",
            component: 'message/ListView',
            title: "İleti Listele",
            theme: Enums.THEME.CLASSIC
        },
        Gonder: {
            path: "message/send",
            component: 'message/SendView',
            title: "İleti Gönder",
            theme: Enums.THEME.CLASSIC
        },
    },
    Notification: {
        List: {
            path: "notification/list",
            component: 'notification/ListView',
            title: "Bildirim Listele",
            theme: Enums.THEME.CLASSIC
        },
        Card: {
            props: [":id"],
            path: "notification/card/{0}",
            component: 'notification/CardView',
            title: "Bildirim Kartı",
            theme: Enums.THEME.CLASSIC
        },
    },
    Person: {
        List: {
            path: "user/list",
            component: 'user/ListView',
            title: "Kullanıcı Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "user/edit/{0}",
            component: 'user/EditView',
            title: "Kullanıcı İşlem",
            theme: Enums.THEME.CLASSIC
        },
        Card: {
            props: [":id"],
            path: "user/card/{0}",
            component: 'user/CardView',
            title: "Kullanıcı Kartı",
            theme: Enums.THEME.CLASSIC
        },
        Profile: {
            path: "user/profile",
            component: 'user/ProfileView',
            title: "Profilim",
            theme: Enums.THEME.CLASSIC
        },
        ForgotPassword: {
            path: "forgot-password",
            component: 'user/ForgotPasswordView',
            title: "Parolamı Unuttum",
            theme: Enums.THEME.EMPTY
        },
        ResetPassword: {
            path: "reset-password",
            component: 'user/ResetPasswordView',
            title: "Parola Yenile",
            theme: Enums.THEME.EMPTY
        },
    },
    Role: {
        List: {
            path: "role/list",
            component: 'role/ListView',
            title: "Rol Listele",
            theme: Enums.THEME.CLASSIC
        },
        Edit: {
            props: [":id"],
            path: "role/edit/{0}",
            component: 'role/EditView',
            title: "Rol İşlem",
            theme: Enums.THEME.CLASSIC
        },
    },
    Message: {
        List: {
            path: "message/list",
            component: 'message/ListView',
            title: "İleti Listele",
            theme: Enums.THEME.CLASSIC
        },
        Send: {
            path: "message/send",
            component: 'message/SendView',
            title: "İleti Gönderim",
            theme: Enums.THEME.CLASSIC
        },
    },
    Setting: {
        All: {
            path: "setting/all",
            component: 'setting/AllView',
            title: "Sistem Yönetimi",
            theme: Enums.THEME.CLASSIC
        },
        General: {
            path: "setting/general",
            component: 'setting/GeneralView',
            title: "Genel Ayarlar",
            theme: Enums.THEME.CLASSIC
        },
        Contact: {
            path: "setting/contact",
            component: 'setting/ContactView',
            title: "İletişim Bilgileri",
            theme: Enums.THEME.CLASSIC
        },
        Email: {
            path: "setting/email",
            component: 'setting/EmailView',
            title: "E-Posta Gönderim Ayarları",
            theme: Enums.THEME.CLASSIC
        },
        Sms: {
            path: "setting/sms",
            component: 'setting/SmsView',
            title: "Sms Gönderim Ayarları",
            theme: Enums.THEME.CLASSIC
        },
        Send: {
            path: "setting/send",
            component: 'setting/SendView',
            title: "İleti Gönderim",
            theme: Enums.THEME.CLASSIC
        },
        Import: {
            path: "setting/import",
            component: 'setting/ImportView',
            title: "İçeri Aktarım",
            theme: Enums.THEME.CLASSIC
        },
        Export: {
            path: "setting/export",
            component: 'setting/ExportView',
            title: "Dışarı Aktarım",
            theme: Enums.THEME.CLASSIC
        },
    },
};